export const schools = [
    {
        name: "SDN 1 Agrabinta",
        position: [-7.409649116044276, 106.98502421379091],
        icon: 'school',
    },
    {
        name: "SDN Salatri",
        position: [-7.4138037214144905, 106.92534506320955],
        icon: 'school',
    },
    {
        name: "SMKN 1 Agrabinta",
        position: [-7.4052216, 106.896711],
        icon: 'school',
    },
    {
        name: "TK Tunas Karya",
        position: [-7.408175578222062, 106.98933720588686],
        icon: 'kindergarten',
    },
];